(() => {
  const SESSION_KEY = 'gl360Language';
  const ENGLISH_VIEW = 'english';
  const currentUrl = new URL(window.location.href);
  const params = currentUrl.searchParams;

  if (params.get('glang') === 'zh') sessionStorage.removeItem(SESSION_KEY);
  if (params.get('view') === ENGLISH_VIEW || params.get('glang') === 'en') sessionStorage.setItem(SESSION_KEY, 'en');
  if (sessionStorage.getItem(SESSION_KEY) !== 'en') return;

  document.documentElement.lang = 'en';
  document.documentElement.dataset.gl360Language = 'en';

  if (window.location.pathname === '/' && params.get('view') !== ENGLISH_VIEW) {
    currentUrl.searchParams.set('view', ENGLISH_VIEW);
    currentUrl.searchParams.set('glang', 'en');
    window.location.replace(currentUrl.pathname + currentUrl.search + currentUrl.hash);
    return;
  }

  const sectionRoot = (key) =>
    document.getElementById(`shopify-section-${key}`) ||
    document.querySelector(`[id$="__${key}"]`);

  const setText = (selector, value, root = document) => {
    if (!root) return;
    const el = root.querySelector(selector);
    if (el && value != null) el.textContent = value;
  };
  const setHTML = (selector, value, root = document) => {
    if (!root) return;
    const el = root.querySelector(selector);
    if (el && value != null) el.innerHTML = value;
  };
  const setTexts = (selector, values, root = document) => {
    if (!root) return;
    root.querySelectorAll(selector).forEach((el, i) => { if (values[i] != null) el.textContent = values[i]; });
  };
  const setHTMLs = (selector, values, root = document) => {
    if (!root) return;
    root.querySelectorAll(selector).forEach((el, i) => { if (values[i] != null) el.innerHTML = values[i]; });
  };

  const translateContact = () => {
    const intro = sectionRoot('contact_intro');
    const location = sectionRoot('contact_location');
    setText('.rich-text__heading', 'Questions? Talk to us', intro);
    setHTML('.rich-text__text', '<p>Questions about choosing a product, your order, delivery or daily use? Get in touch with us. For more complex TCM wellness concerns, our team can also provide a professional assessment.</p>', intro);
    setText('.button', 'WhatsApp Us', intro);
    setHTML('.image-with-text__text', '<p><strong>No. 23, Lorong Satu</strong><br>34200 Parit Buntar, Perak</p><p>Opening hours: 10:00 AM – 7:00 PM<br>Closed on Thursday</p><p>WhatsApp: +6011 5638 0602</p>', location);
    setText('.button', 'WhatsApp Us', location);
  };

  const translateAbout = () => {
    const intro = sectionRoot('about_intro');
    const story = sectionRoot('about_story');
    const values = sectionRoot('about_values');
    const close = sectionRoot('about_close');

    setText('.rich-text__heading', 'Make wellness something you can do every day', intro);
    setHTML('.rich-text__text', '<p>Good Life 360 began with everyday health care in Parit Buntar, bringing together TCM wellness thinking, real grains and modern lifestyles into choices that are easier to understand and easier to maintain.</p><p>From rice water and healing tea to daily nutrition, we do not believe wellness needs to feel complicated. What matters most is simple: what does your body need today?</p>', intro);
    setText('.image-with-text__heading', 'Built from real everyday observations', story);
    setHTML('.image-with-text__text', '<p>Through daily conversations in our clinic and with customers, we keep seeing the same thing: wellness that lasts is usually not more complicated — it is clearer.</p><p>That is why we organise different needs into simple choices, so every drink and every nutrition product has a clear everyday role.</p>', story);
    setText('.button', 'Contact Us', story);
    setText('.multicolumn__title .title', 'Three things that matter to us', values);
    setTexts('.multicolumn-card__info h3', ['Real Ingredients', 'Clear Purpose', 'Easy to Continue'], values);
    setHTMLs('.multicolumn-card__info .rte', [
      '<p>Grains, herbs and everyday nutrition should begin with ingredients you can understand and explain clearly.</p>',
      '<p>We do not present every product as a cure-all. Different products are designed for different everyday needs.</p>',
      '<p>Good wellness is not about doing everything at once. It is about choosing habits you can keep doing every day.</p>'
    ], values);
    setText('.rich-text__heading', 'You do not have to change everything at once', close);
    setHTML('.rich-text__text', '<p>Start with one cup, one meal, or one habit that feels easier to keep.</p>', close);
    setTexts('.button', ['Explore Rice Water', 'Explore Healing Tea'], close);
  };

  const translateRiceWaterGuide = () => {
    const intro = sectionRoot('rice_intro');
    const needs = sectionRoot('shop_by_need');
    const family = sectionRoot('rice_family');
    const tasteGuide = sectionRoot('taste_guide');
    const ingredients = sectionRoot('ingredients_story');
    const cert = sectionRoot('cert_title');
    const faq = sectionRoot('rice_faq');
    const finalCta = sectionRoot('final_cta');

    setText('.rich-text__heading', 'Find the rice water that fits your day', intro);
    setHTML('.rich-text__text', '<p>9 rice water and rice milk blends for gut comfort, regularity, nutrition, nourishment and everyday energy. Start with what you need most today.</p>', intro);
    setTexts('.button', ['Choose by Need', 'View All Rice Water'], intro);

    setText('.multicolumn__title .title', 'What would you like to support today?', needs);
    setTexts('.multicolumn-card__info h3', ['Gut', 'Regularity', 'Nutrition', 'Nourish', 'Energy'], needs);
    setHTMLs('.multicolumn-card__info .rte', [
      '<p>For a sensitive stomach or days when you feel uncomfortable after meals, start with a gentler everyday option.</p>',
      '<p>A simple daily option when you want to support regularity and everyday gut care.</p>',
      '<p>For everyday nutrition and calcium support, with a smoother, creamier rice-milk texture.</p>',
      '<p>For those who enjoy warming grain flavours such as red bean and black sesame as part of everyday nourishment.</p>',
      '<p>For mornings or workdays when you want a more energising flavour, start with coffee or matcha.</p>'
    ], needs);
    setTexts('.multicolumn-card__info .link', ['Soothing Rice Water', 'Mixed Berries Rice Water', 'Avocado Rice Milk', 'Black Sesame Rice Water', 'Matcha Rice Water'], needs);

    setText('.collection__title .title', 'Meet the Rice Water Family', family);

    const tasteRows = tasteGuide ? tasteGuide.querySelectorAll('.image-with-text__grid') : [];
    const tastes = [
      ['LIGHT & GRAINY', 'Light, grain-forward and easy to drink', '<p><a href="/products/barley-rice-water-box"><strong>Pearl Barley Rice Water</strong></a> · <a href="/products/red-bean-rice-water-box"><strong>Red Bean Rice Water</strong></a><br>A good place to start if you prefer a clean, grain-forward taste.</p>'],
      ['SMOOTH & CREAMY', 'Smooth and creamy like rice milk', '<p><a href="/products/avocado-rice-milk-box"><strong>Avocado Rice Milk</strong></a> · <a href="/products/chocolate-oat-rice-milk-box"><strong>Chocolate Oat Rice Milk</strong></a> · <a href="/products/black-sesame-rice-water-box"><strong>Black Sesame Rice Water</strong></a><br>Start here if you prefer a richer, fuller and smoother texture.</p>'],
      ['FRUITY & GENTLE', 'Berries with a gentle grain finish', '<p><a href="/products/mixberries-rice-water-box"><strong>Mixed Berries Rice Water</strong></a> · <a href="/products/soothing-rice-water-box"><strong>Soothing Rice Water</strong></a><br>An easy everyday choice when you prefer a gentler, more approachable flavour.</p>'],
      ['BOLD & BALANCED', 'Coffee and matcha for everyday energy', '<p><a href="/products/arabica-rice-water-box"><strong>Arabica Rice Water</strong></a> · <a href="/products/matcha-rice-water"><strong>Matcha Rice Water</strong></a><br>If you enjoy coffee or matcha, these make rice water easy to fit into mornings and workdays.</p>']
    ];
    tasteRows.forEach((row, i) => {
      if (!tastes[i]) return;
      setText('.caption-with-letter-spacing', tastes[i][0], row);
      setText('.image-with-text__heading', tastes[i][1], row);
      setHTML('.image-with-text__text', tastes[i][2], row);
    });

    setText('.image-with-text__heading', 'Start with real grains', ingredients);
    setHTML('.image-with-text__text', '<p>Built from red rice, brown rice, grains, seeds and plant ingredients, each of the 9 blends has a clear everyday role — not just a different flavour.</p>', ingredients);
    setText('.button', 'View All Rice Water', ingredients);
    setText('.rich-text__heading', 'Certified with Care', cert);
    setHTML('.rich-text__text', '<p>Everyday reassurance, made clear and easy to see.</p>', cert);

    const faqRows = faq ? faq.querySelectorAll('.accordion') : [];
    const faqs = [
      ['Natural Ingredients', '<ul><li>No Gum & Thickener</li><li>No Preservatives</li><li>No Artificial Colours & Flavours</li><li>No Refined Sugar & Artificial Sweetener</li><li>Non-GMO</li><li>Dairy-Free</li><li>Zero Cholesterol</li></ul>'],
      ['No Refined Sugar? Why Is Sugar Listed?', '<p>Sugar shown in the nutrition panel can come naturally from ingredients such as grains. “No refined sugar added” does not mean total sugar must be zero. Please refer to each product label for the actual value.</p>'],
      ['With & Without Legumes', '<p>Different rice water blends contain different amounts of legumes. If you are sensitive to legumes, check the ingredient list for the specific product. If you need to avoid legumes, start with a formula that does not contain them.</p>'],
      ['Gluten', '<p>The grains used vary from blend to blend, so gluten content can differ. If you require a strict gluten-free diet, refer to the ingredients and allergen information on the product packaging and choose only products clearly labelled for your needs.</p>'],
      ['Rice Water vs Rice Milk', '<p><strong>Rice Water</strong> focuses on a lighter everyday grain drink with different functional directions. <strong>Rice Milk</strong> has a smoother, creamier texture and may include different nutritional features depending on the product. The simplest way to choose: start with your needs, then choose the taste and texture you prefer.</p>'],
      ['Can It Replace a Meal?', '<p>Whether it is enough to replace a meal depends on serving size and your overall needs for calories, protein, fibre and other nutrients. For everyday drinking, treat rice water or rice milk as a drink or part of a snack. If using it as a meal, refer to the nutrition label and your individual dietary needs.</p>']
    ];
    faqRows.forEach((row, i) => {
      if (!faqs[i]) return;
      setText('.accordion__title', faqs[i][0], row);
      setHTML('.accordion__content', faqs[i][1], row);
    });

    setText('.rich-text__heading', 'Still not sure? Start with what you want to support today', finalCta);
    setHTML('.rich-text__text', '<p>Choose one direction first, then pick a flavour you would enjoy drinking every day. Keeping it simple makes it easier to stay consistent.</p>', finalCta);
    setText('.button', 'View All Rice Water', finalCta);
  };

  const translateEastMalaysiaShipping = () => {
    const shipping = sectionRoot('rich_text_NUtD6K');
    setHTML('.rich-text__text', '<h3><strong>A Better Balance for Sabah, Sarawak & Labuan</strong></h3><p>We’ve reviewed our East Malaysia delivery arrangement and worked with our logistics partners to find a better balance — keeping shipping practical for smaller orders, while bringing back FREE Shipping for orders RM300 and above.</p><p>🚚 <strong>Shipping from RM13</strong><br>🎁 <strong>FREE Shipping with RM300 spend</strong><br>📍 <strong>Sabah · Sarawak · Labuan</strong></p><p>For orders below RM300, shipping is calculated based on parcel weight, starting from RM13.</p><p>For orders of <strong>RM300 and above, shipping is FREE</strong> and will be applied automatically at checkout — <strong>no promo code needed</strong>.</p><p>We know delivery to East Malaysia comes with higher logistics costs. Rather than increasing the standard shipping fee across the board, we wanted to keep smaller orders accessible while making larger orders more worthwhile.</p><p>A simple and more balanced way to shop with Good Life 360 — wherever you are in Malaysia. 🌾</p><p><strong>Estimated delivery time:</strong> 5–8 business days</p>', shipping);
  };

  const rewriteLink = (anchor) => {
    const href = anchor.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return;
    let url;
    try { url = new URL(href, window.location.origin); } catch (_) { return; }
    if (url.origin !== window.location.origin) return;
    url.searchParams.set('glang', 'en');
    if (url.pathname === '/') url.searchParams.set('view', ENGLISH_VIEW);
    else url.searchParams.delete('view');
    anchor.setAttribute('href', url.pathname + url.search + url.hash);
  };

  const runEnglishMode = () => {
    if (document.body) document.body.classList.add('gl360-english-mode');
    translateContact();
    translateAbout();
    translateRiceWaterGuide();
    translateEastMalaysiaShipping();
    document.querySelectorAll('a[href]').forEach(rewriteLink);
    document.addEventListener('click', (event) => {
      const anchor = event.target.closest && event.target.closest('a[href]');
      if (anchor) rewriteLink(anchor);
    }, true);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runEnglishMode, { once: true });
  else runEnglishMode();
})();